import { getPluginSlots } from "@/plugin/slots"

function registeredFocusPath(focus: string): string | undefined {
  const registration = getPluginSlots().focusRegistrations.find((r) => r.focus === focus)
  return registration ? registration.path ?? `/${focus}` : undefined
}

/** Root path for the current focus (dashboard home). Domains set it with `focus.register({ path })`. */
export function getFocusRoute(f: string | null): string {
  if (f) return registeredFocusPath(f) ?? `/${f}`
  const first = getPluginSlots().focusRegistrations.find((r) => r.tree)
  return first ? registeredFocusPath(first.focus)! : "/profile"
}
